"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Dialog_1 = __importDefault(require("@mui/material/Dialog"));
var ButtonCombo = __importStar(require("./M_ButtonComboHeader"));
var Component = function (p) {
    var articleTypeText = p.articleType === 'ar-model' ? 'AR Model' : 'article';
    return (Preact.h(Dialog_1.default, { open: p.show }, (Preact.h(Box_1.default, { sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '16px',
            width: '481px',
            height: '239px',
            padding: '46px',
            boxSizing: 'border-box',
        } },
        Preact.h(Typography_1.default, { variant: "h4" }, !p.failed ? "Delete ".concat(articleTypeText, "?") : 'Delete failed'),
        Preact.h(Typography_1.default, { variant: "body1", sx: { marginY: '35px' } }, !p.failed
            ? "This will permanently delete the ".concat(articleTypeText)
            : "Failed to delete this ".concat(articleTypeText, ", please try again")),
        Preact.h(ButtonCombo.Component, { secondaryText: "Cancel", secondaryAction: p.onCancelClick, disableSecondary: p.disabled, primaryText: "Delete", primaryAction: p.onDeleteClick, disablePrimary: p.disabled })))));
};
exports.Component = Component;
